import { createContext, useContext } from "react";

import { type ModalDefinition } from "./types";

export interface ModalsProps {
  modals: ModalDefinition[];
  pushModal: (modal: ModalDefinition, reset?: boolean) => void;
  hideModal: (modalType: ModalDefinition["type"]) => void;
}

export const ProjectModalsContext = createContext<ModalsProps>(
  {} as ModalsProps
);

export const useModals = () => useContext(ProjectModalsContext);
